import React, { useEffect } from "react";
import { useGetSpotifyLoginUrl } from "../api-generated";
import ErrorLoading from "./ErrorLoading";
import CenteredLoading from "./CenteredLoading";

const SpotifyLogin: React.FC = () => {
  const { data, error } = useGetSpotifyLoginUrl();

  useEffect(() => {
    if (data) {
      window.location.href = data;
    }
  }, [data]);

  if (error) {
    return <ErrorLoading error={error} />;
  }

  return <CenteredLoading />;
};

export default SpotifyLogin;
